(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["henk-mobile-header"] && !Shopify.designMode) return;
  try {
    const header = document.querySelector('.henk-mobile-header');
  const menuButton = header?.querySelector('.henk-mobile-header__menu-button');

  menuButton?.addEventListener('click', () => {
    const open = header.toggleAttribute('data-menu-open');
    menuButton.setAttribute('aria-expanded', open);

    if (!open) {
      nav?.querySelectorAll('details[open]').forEach((details) => {
        details.open = false;
      });

      nav?.querySelector('.is-active')?.classList.remove('is-active');
      nav?.querySelector('[data-nav-level="main"]')?.classList.add('is-active');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
